import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PujcovnaVozidel = {
	name: NAME,
	apiProvider,
	router,
};
